export const I18N_CONFIG = {
    DEFAULT_NAMESPACE: 'translation',
    NAMESPACES: ['translation'],
    STORAGE_PREFIX: 'i18next_res_',
    STORAGE_EXPIRATION_DAYS: 7,
    COOKIE_MAX_AGE_DAYS: 365,
} as const;

export const I18N_BACKEND_CONFIG = {
    LOCAL_STORAGE_PREFIX: 'i18next_res_',
    EXPIRATION_TIME_MS: 7 * 24 * 60 * 60 * 1000,
} as const;

